const clean = (params = {}) => Object.fromEntries(Object.entries(params).filter(([, value]) => value !== "" && value != null));

const createInventorySourceApi = ({ baseUrl, getToken }) => {
  const request = async (path, { method = "GET", body, params } = {}) => {
    const query = new URLSearchParams(clean(params)).toString();
    const token = typeof getToken === "function" ? getToken() : getToken;
    const response = await fetch(`${String(baseUrl || "").replace(/\/$/, "")}${path}${query ? `?${query}` : ""}`, {
      method,
      headers: { Accept: "application/json", "Content-Type": "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) },
      ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw Object.assign(new Error(data.error || `HTTP ${response.status}`), { status: response.status, code: data.code });
    return data;
  };
  return {
    getPlatform: () => request("/dropshipping/inventory-source/platform"),
    getConnection: () => request("/dropshipping/inventory-source/connection"),
    getSignup: () => request("/dropshipping/inventory-source/signup"),
    connect: (payload = {}) => request("/dropshipping/inventory-source/connect", { method: "POST", body: payload }),
    testConnection: (payload = {}) => request("/dropshipping/inventory-source/test-connection", { method: "POST", body: payload }),
    updateConnection: (payload = {}) => request("/dropshipping/inventory-source/connection", { method: "PUT", body: payload }),
    disconnect: () => request("/dropshipping/inventory-source/connection", { method: "DELETE" }),
    getSuppliers: () => request("/dropshipping/inventory-source/suppliers"),
    syncSuppliers: () => request("/dropshipping/inventory-source/suppliers/sync", { method: "POST" }),
    getSupplierProducts: (supplierId, params) => request(`/dropshipping/inventory-source/suppliers/${supplierId}/products`, { params }),
    getProducts: (params) => request("/dropshipping/inventory-source/products", { params }),
    getProduct: (id) => request(`/dropshipping/inventory-source/products/${id}`),
    importProduct: (payload) => request("/dropshipping/inventory-source/products/import", { method: "POST", body: payload }),
    syncAll: () => request("/dropshipping/inventory-source/sync", { method: "POST" }),
    syncProduct: (id) => request(`/dropshipping/inventory-source/products/${id}/sync`, { method: "POST" }),
    getImportedProducts: (params) => request("/dropshipping/inventory-source/imported-products", { params }),
    getOrders: (params) => request("/dropshipping/inventory-source/orders", { params }),
    createSupplierOrder: (orderId, sellerId) => request(`/dropshipping/inventory-source/orders/${orderId}/create`, { method: "POST", body: sellerId ? { sellerId } : {} }),
    syncOrder: (id) => request(`/dropshipping/inventory-source/orders/${id}/sync`, { method: "POST" }),
    getErrors: () => request("/dropshipping/inventory-source/errors"),
    getAdminOverview: () => request("/dropshipping/inventory-source/admin/overview"),
    getAdminConnections: () => request("/dropshipping/inventory-source/admin/connections"),
    getAdminSuppliers: () => request("/dropshipping/inventory-source/admin/suppliers"),
    getAdminProducts: () => request("/dropshipping/inventory-source/admin/products"),
    getAdminLogs: () => request("/dropshipping/inventory-source/admin/logs"),
    getAdminOrders: () => request("/dropshipping/inventory-source/admin/orders"),
    disableConnection: (id) => request(`/dropshipping/inventory-source/admin/connections/${id}/disable`, { method: "PATCH" }),
    disableProduct: (id) => request(`/dropshipping/inventory-source/admin/products/${id}/disable`, { method: "PATCH" }),
    updateAdminPlatform: (payload) => request("/dropshipping/inventory-source/admin/platform", { method: "PATCH", body: payload }),
    syncAllSellers: () => request("/dropshipping/inventory-source/admin/sync", { method: "POST" }),
  };
};

module.exports = { createInventorySourceApi };
